export function stripHTMLTags(html?: string): string {
  if (!html)
    return ''

  return html
    // Replace common block elements with newlines
    .replace(/<\/(p|div|tr|li|br)>/gi, '\n')
    // Replace table cells with tab separation
    .replace(/<\/(td|th)>/gi, '\t')
    // Remove all HTML tags
    .replace(/<([^>]+)>/g, '')
    // Fix multiple spaces
    .replace(/\s+/g, ' ')
    // Fix multiple newlines
    .replace(/\n\s*\n/g, '\n')
    // Fix multiple tabs
    .replace(/\t\s*\t/g, '\t')
    // Trim whitespace
    .trim()
}
